import layout from '@/layout'

export default {
  path: '/sys',
  component: layout,
  redirect: '/sys/manage',
  name: 'interfacePermission',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: '/sys/permission',
      component: () => import('@/views/sys/permission-list/index.vue'),
      meta: {
        title: '接口权限',
        icon: 'api'
      }
    }
  ]
}
